import { FC } from "react";
import { Button, ButtonProps } from "../ui/button";
import * as Icon from "../icons";
import { T } from "@tolgee/react";

export const CheckCrpQuantitiesTrigger: FC<ButtonProps> = ({ ...props }) => (
  <Button {...props}>
    <Icon.HelpCircle id="check-crp-quantities-dialog-trigger" />
    <T keyName="check-crp-quantities-dialog-trigger-button-text" />
  </Button>
);
